// Scripts are small now so don't bother lazy loading only required renderer
import { captureException, withScope } from "@sentry/react";
import type { RenderRunner } from "./render-runner-type.ts";
import { createRenderWorkerBridge } from "./render-worker-bridge.ts";
import { createRenderRunner } from "./render-runner.ts";

function createRenderer(): RenderRunner<HTMLCanvasElement> {
	// Note: https://stackoverflow.com/a/72681399/7743183
	// you should even never start more Workers than navigator.hardwareConcurrency - 1.
	// Failing to do so, your Workers's concurrency would be done through task-switching
	// instead of true parallelism, ant that would incur a significant performance penalty.

	// The check for 2 concurrency here assumes we're using main thread + build worker.

	// Safari Mar 27 2023 started supporting transferControlToOffscreen
	/* eslint-disable @typescript-eslint/no-unnecessary-condition */
	if (
		!HTMLCanvasElement.prototype.transferControlToOffscreen ||
		navigator.hardwareConcurrency <= 2
	) {
		console.warn("Using main thread renderer");
		return createRenderRunner({
			pendingRenderMethod: "timeout",
			// Main-thread fallback: report straight to Sentry (no worker boundary).
			onError: (error) => {
				withScope((scope) => {
					scope.setTag("source", "render-main-thread");
					captureException(error);
				});
			},
		});
	}

	return createRenderWorkerBridge();
}

export default createRenderer;
